import { IElement } from "core-integration/src/store/elements/types";
import { usePlosTranslations } from "../../../contexts/PlosTranslationsContext";
import PlayerNotes from "../../../img/icons/player-notes.svg?react";
import { ElementIcon } from "../../tooltips/ElementIcon";
import { ElementIconButton } from "../../tooltips/ElementIconButton";
import { notesIcon } from "../playerNotes.css";

interface PlayerNotesIconProps {
  element: IElement;
  action?: () => void;
  useDarkIconInDarkMode?: boolean;
}

const PlayerNotesIcon = ({
  element,
  action,
  useDarkIconInDarkMode = false,
}: PlayerNotesIconProps) => {
  const { playerNotes } = usePlosTranslations();
  const hasPlayerNotes = Boolean(element.scout_risks?.length);
  const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

  if (!hasPlayerNotes) {
    return null;
  }

  const iconVariant =
    prefersDark && !useDarkIconInDarkMode ? "light" : "default";

  const label = playerNotes.label;
  const tooltipText = playerNotes.tooltipText;
  const icon = <PlayerNotes className={notesIcon[iconVariant]} aria-hidden />;

  if (action) {
    return (
      <ElementIconButton
        label={label}
        tooltipText={tooltipText}
        onPress={action}
      >
        {icon}
      </ElementIconButton>
    );
  }

  return (
    <ElementIcon label={label} tooltipText={tooltipText}>
      {icon}
    </ElementIcon>
  );
};

export default PlayerNotesIcon;
